export default "__VITE_ASSET__CNFwLc3E__"